import styles from './Ordertable.module.css'
import { useEffect, useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import 'react-datepicker/dist/react-datepicker.css';
import { ko } from "date-fns/esm/locale";
import { addDays, differenceInDays } from 'date-fns';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import swal from 'sweetalert';
import { Link } from "react-router-dom"
import { dbService } from 'fbase';
import { addDoc, collection } from "firebase/firestore";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Ordertable({product, userObj, isLoggedIn }){
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
        // if(new Date(product.reserv_date).getTime() <= new Date(state[0].endDate).getTime()
        // || new Date(product.return_date).getTime() >= new Date(state[0].startDate).getTime()
        // ){
        //     return swal("해당기간에는 대여가 불가합니다!", "이미 예약이 잡혀있습니다.","error")
        // }

        onSubmit();
        if(isLoggedIn){
            emailjs.sendForm("carryvilly", "template_4imxwbm", form.current, "QHRm4EKaGVeosJWZR")
            .then((result) => {
                swal("주문 완료!", "프로필과 메일함을 확인하세요!","success").then((okay)=>{
                    window.location.replace(process.env.PUBLIC_URL + "/review/");
                })
            }, (error) => {
                swal("잠시 후 다시 시도해주세요...", "", "error");
            });
        } else {
            emailjs.sendForm("carryvilly", "template_4imxwbm", form.current, "QHRm4EKaGVeosJWZR")
            .then((result) => {
                swal("주문 완료!", "메일함을 확인해주세요!","success").then((okay)=>{
                    window.location.replace(process.env.PUBLIC_URL + "/review/");
                })
            }, (error) => {
                swal("잠시 후 다시 시도해주세요...", "", "error");
            });
        }
    };
    const onSubmit = async (event) => {
        const orderObj = {
            ...inputs,
            days,
            term,
            rentaltime,
            price: `${price}원`,
            mini,
            location,
            createdAt: new Date(),
            createdTime: Date.now(),
            reservDate: new Intl.DateTimeFormat("kr-KO").format(state[0].startDate),
            returnDate: new Intl.DateTimeFormat("kr-KO").format(state[0].endDate),
            cid: product.id,
            fbid: product.fbid,
            payment: false
        }
        const orderlogObj = {
            name,
            type:"주문",
            createdTime: Date.now()
        }
        await addDoc(collection(dbService, "orderlist"), orderObj);
        await addDoc(collection(dbService, "orderlog"), orderlogObj);
    }
    const [inputs, setInputs] = useState({
        cname: "",
        cnumber: "",
        size: "",
        name: "",
        email: "",
        phone: "",
        nation: "",
        city:"",
        address: "",
        location: ""
    });

    const {cname, cnumber, size, name, email, phone, nation, city, address, location} = inputs;

    useEffect(()=>{
        if(userObj){
            setInputs({
                ...inputs,
                email: userObj.email,
                cname: product.name,
                cnumber: product.num,
                size: `${product.type}/${product.size}`,
            })
        } else {
            setInputs({
                ...inputs,
                cname: product.name,
                cnumber: product.num,
                size: `${product.type}/${product.size}`,
            })
        }
    }, [product.name, product.num, product.type, product.size, userObj])

    const onChange = (e) => {
        const {name, value} = e.target;
        setInputs({
            ...inputs,
            [name]: value,
        })
    }

    const [minDate, setMinDate] = useState(new Date())
    const getMinDate = () => {
        if(product.return_date === null || new Date(product.return_date).getTime() < new Date().getTime()){
            setMinDate(new Date());
        } else {
            setMinDate(new Date(product.return_date))
        }
    }

    useEffect(()=>{
        getMinDate(new Date(product.return_date))
    }, [product.return_date])

    const options = {
        day: 'numeric',
        month: 'long', 
        year: 'numeric',
        weekday: 'short'
    };

    const [state, setState] = useState([
        {
            startDate: addDays(new Date(), 2),
            endDate: addDays(minDate, 7),
            key: "selection",
        }
    ])

    const firstDay = new Intl.DateTimeFormat("kr-KO", options).format(state[0].startDate);
    const lastDay = new Intl.DateTimeFormat("kr-KO", options).format(state[0].endDate);

    const [days, setDays] = useState(differenceInDays(state[0].endDate, state[0].startDate));
    const [term, setTerm] = useState(`${firstDay} ~ ${lastDay}`)
    
    useEffect(()=>{
        setDays(differenceInDays(state[0].endDate, state[0].startDate));
        setTerm(`${firstDay} ~ ${lastDay}`);
    }, [state])

    const [rentaltime, setRentaltime] = useState("12:00:00")
    const getRentaltime = (event) => {
        setRentaltime(event.target.value);
    }

    const [mini, setMini] = useState("추가 안 함");
    const getMini = () => {
        if(document.getElementById("yesMini").checked){
            setMini("추가(+2,000원)");
            setPrice((current) => current + 2000);
        } else {
            setPrice((current) => current - 2000);
            setMini("추가 안 함");
        }       
    }

    const [price, setPrice] = useState(7000);
    const getPrice = () => {
        if(document.getElementById("yesMini").checked){
            setPrice(Math.ceil(days / 7) * 7000 + 2000);
        } else {
            setPrice(Math.ceil(days / 7) * 7000);
        }  
    }
    
    useEffect(() => {
        getMini();
        getPrice(); // 초기 가격 설정
    }, [days]);

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.wrapper}>
                <div className={styles.card}>
                    <div className={styles.cardBody}>
                        <h2 className={styles.title}>ORDER</h2>
                        <form ref={form} onSubmit={sendEmail}>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <h5 className="text-dark"><span name="cnumber">No.{cnumber}</span> {cname}</h5>
                                    <p className="small text-muted">{size}인치</p>
                                    <input style={{display: "none"}} name="cnumber" value={`No.${cnumber}`} readOnly/>
                                    <input style={{display: "none"}} name="cname" value={cname} readOnly/>
                                    <input style={{display: "none"}} name="size" value={`${size}인치`} readOnly/>    
                                </div>
                            </div>
                            <div className={styles.row}>
                                <div className={styles.col2}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.label}><i class="fa fa-user" aria-hidden="true"></i> 이름</label>
                                        <input
                                            className={styles.inputStyle4}
                                            type="text"
                                            name="name"
                                            id="username"
                                            onChange={onChange}
                                            value={name}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.row}>
                                <div className={styles.col2}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.label}><i class="fa fa-envelope" aria-hidden="true"></i> 이메일</label>
                                        <input
                                            className={styles.inputStyle4}
                                            type="email"
                                            name="email"
                                            id="useremail"
                                            value={email}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className={styles.col2}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.label}><i class="fa fa-mobile" aria-hidden="true"></i> 연락처</label>
                                        <input
                                            className={styles.inputStyle4}
                                            name="phone"
                                            type="tel"
                                            id="userphone"
                                            value={phone}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.row}>
                                <div className={styles.col2}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.label}><i class="fa fa-globe" aria-hidden="true"></i> 여행국가</label>
                                        <input
                                            type="text"
                                            name="nation"
                                            id="nation"
                                            className={styles.inputStyle4}
                                            value={nation}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className={styles.col2}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.label}><i class="fa fa-plane" aria-hidden="true"></i> 여행도시</label>
                                        <input
                                            type="text"
                                            name="city"
                                            id="city"
                                            className={styles.inputStyle4}
                                            value={city}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <label className={styles.label}><i class="fa fa-calendar" aria-hidden="true"></i> 대여기간</label>
                            <input style={{display: "none"}} name='term' value={term} readOnly/>
                            <div style={{textAlign: "center"}}>
                            <DateRange
                                ranges={state}
                                locale={ko}
                                minDate={addDays(new Date(),2)}
                                onChange={(item) => {
                                    setState([item.selection])
                                }}
                                required
                            />
                            </div>
                            <div className={styles.row}>
                                <div className={styles.col2}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.label}><FontAwesomeIcon icon="fa-solid fa-clock" /> 대여시간</label>
                                        <input
                                            type="time"
                                            id="time"
                                            name='time'
                                            className={styles.inputStyle4}
                                            value={rentaltime}
                                            min="10:00:00"
                                            max="22:00:00"
                                            onChange={getRentaltime}
                                        />
                                    </div>
                                </div>
                                <div className={styles.col2}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.label}><i class="fa fa-map-marker" aria-hidden="true"></i> 대여장소</label>
                                        <select className={styles.inputStyle4} id='location' name='location' onChange={onChange} required>
                                            <option className={styles.inputStyle4} value="">주소 선택</option>
                                            <option className={styles.inputStyle4} value="동작구 강남초등길24 지하1층">동작구 강남초등길24</option>
                                            <option className={styles.inputStyle4} value="성북구 석관동 261-77 주영이네 1층">성북구 석관동 261-77</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.row}>
                                <div className={styles.col2}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.label}><i class="fa fa-suitcase" aria-hidden="true"></i> 미니캐리어</label>
                                        <div className={styles.pT10}>
                                            <label className={styles.radioContainer} style={{marginRight:"1.5rem"}}>추가 안 함
                                                <input type="radio" id='noMini' name="mini" value="추가 안 함" onChange={getMini} defaultChecked />
                                                <span className={styles.checkmark}></span>
                                            </label>
                                            <label className={styles.radioContainer}>추가(+2,000원)
                                                <input type="radio" id='yesMini' name="mini" value="추가(+2,000원)" onChange={getMini} />
                                                <span className={styles.checkmark}></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.col2}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.label}><i class="fa fa-question-circle" aria-hidden="true"></i> 기타 요청사항</label>
                                        <input
                                            type="text"
                                            name="address"
                                            id="address"
                                            placeholder='ex) 미니캐리어 번호'
                                            className={styles.inputStyle4}
                                            value={address}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.row}>
                                <div>
                                    <label className={styles.label}>총 대여일</label>
                                    <h3>{days}일</h3>
                                    <input style={{display: "none"}} name='days' value={days} readOnly/>
                                </div> 
                                <div style={{textAlign: "right"}}>
                                    <label className={styles.label}>총 대여가격</label>
                                    <h2>{price}원</h2>
                                    <input style={{display: "none"}} name='price' value={price} readOnly/>
                                </div> 
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{marginTop:"2rem"}}>
                                <h5 className="text-dark fw-bold" style={{marginBottom: "0"}}>CARRYVILLY</h5>
                                <button
                                    className="btn btn-primary"
                                    type="submit"
                                >
                                    <strong>주문완료</strong>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Ordertable;